import { NavLink } from "react-router-dom/cjs/react-router-dom";
import { useContext } from "react";

import Button from "../FormElements/Button";
import { AuthContext } from "../../context/auth-context";

import './NavLinks.css'

const NavLinks = () => {
  const auth = useContext(AuthContext)
    return (
      <ul className="nav-links">
        <li>
          <NavLink to="/" exact>
            All Users
          </NavLink>
        </li>
        {auth.isLoggedIn && (
          <li>
            <NavLink to={`/${auth.userId}/places`}>My places</NavLink>
          </li>
        )}
        {auth.isLoggedIn && (
          <li>
            <NavLink to="/places/new">Add Place</NavLink>
          </li>
        )}
        {!auth.isLoggedIn ? (
          <li>
            <NavLink to="/auth">Authenticate</NavLink>
          </li>
        ) : (
          <li>
            <Button onClick={auth.logout}>Logout</Button>
          </li>
        )}
      </ul>
    )
}

export default NavLinks